import styled from 'styled-components'
import { Switch } from 'antd'
import { calculateAlphaColor } from 'core/utils/colors'

const AntSwitchStyled = styled(Switch)`
  &&& {
    &.ant-switch-checked {
      background-color: ${props => props.theme.colors.color1.bg};
    }
    :after {
      box-shadow: 0 2px 4px 0 ${props => calculateAlphaColor(props.theme.colors.color1.bg, 0.5)};
    }
  }
`

export default AntSwitchStyled
